/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
// eslint-disable-next-line jsx-a11y/click-events-have-key-events

import React from 'react';
import {
    bool, object, func, arrayOf, number, shape, string, array,
} from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import KeyboardArrowUp from '@material-ui/icons/KeyboardArrowUp';
import Media from 'react-media';
import { compose } from 'recompose';

import withPageView from '../../../../helpers/tracking/hocs/withPageView';
import EventDispatcher from '../../state/reducers/EventDispatcher';
import DeliveryHours from './DeliveryHours';
import OrderList from './OrderList';
import TrackOrderByZipCode from './TrackOrderByZipCode';
import Loading from '../../common/Loading';
import CUSTOM_BREAKPOINTS from '../../style/customBreakpoints';
import { TrackOrderStyle } from '../../style/TrackOrderStyle';
import getSiteConfig from '../../utils/getSiteConfig';
import configENV from '../../config';
import DesktopOrderHeader from '../DesktopOrdersList/DesktopOrderHeader';
import DesktopTrackOrder  from './DesktopTrackOrder/DesktopTrackOrder';
import AccountLeftMenu from '../../common/Desktop/AccountLeftMenu';
import ErrorPage from '../../common/ErrorPage';
import GraphqlSeoHeadTags from '../../../../components/GraphqlComponents/GraphqlCommonComponents/GraphqlSeoHeadTags/GraphqlSeoHeadTags';
import OrderTrackingOutage from '../OrderTrackingOutage/OrderTrackingOutage';
import { getAddToCartError } from '../../../../../state/ducks/AddToCart/AddToCart-Selectors';
import { getSSRDeviceType } from '../../../../../state/ducks/App/App-Selectors';
import { trackPage } from '../../../../helpers/tracking/common/commonTrackingHelpers';
import { getIsAuthenticatedStatus, getBrand } from '../../../../../state/ducks/Member/ducks/Common/Common-Selectors';
import AccountHome from '../MyAccount/AccountHome';

const { PERSIST_KEY } = configENV;

const styles = ({ typography, palette }) => TrackOrderStyle(typography, palette);

class TrackOrders extends React.Component {
    // eslint-disable-next-line camelcase
    UNSAFE_componentWillMount = async () => {
        const {
            fetchOrdersByEmail, userProfile: { isAuthenticated }, featureFlags, ssrDeviceType,
            getAuthenticatedStatus,
        } = this.props;
        // isAuthenticated wasn't immediately updated by Auth0 if users sign in from /account/orders
        // so we use `getIsAuthenticatedStatus` to get the login status instead
        if (isAuthenticated || getAuthenticatedStatus) await fetchOrdersByEmail(featureFlags, ssrDeviceType);
    };

    componentDidMount = () => {
        if (typeof window !== 'undefined') {
            window.scrollTo(0, 0);
        }
    };

    componentDidUpdate = async (prevProps) => {
        const {
            fetchOrdersByEmail, featureFlags, ssrDeviceType, getAuthenticatedStatus,
        } = this.props;
        // isAuthenticated wasn't immediately updated by Auth0 if users sign in from /account/orders
        // so we use `getIsAuthenticatedStatus` to get the login status instead
        // fetching order list if user is clicking sign in on global header from orders page
        if (prevProps.getAuthenticatedStatus === false && getAuthenticatedStatus === true) await fetchOrdersByEmail(featureFlags, ssrDeviceType);
    }

    componentWillUnmount = () => {
        const {
            clearRossError, getAuthenticatedStatus, isErrorResponse, error,
        } = this.props;
        if (!getAuthenticatedStatus && isErrorResponse && error && error.errorMessage) {
            clearRossError(); // Reset error state on component unmount for guest user to access track order page when ross gives error
        }
    }

    handleBackToTopClicked = () => {
        if (typeof window !== 'undefined') {
            window.scrollTo(0, 0);
        }
    };

    showStockErrorMessage = () => (
        <div className="add-to-cart-error">We&apos;re sorry, this product is not available for purchase.
            Please try again later or contact customer service for assistance
        </div>
    )

    render() {
        const {
            classes,
            userProfile,
            featureFlags,
            userProfile: { isAuthenticated },
            isFetchingModal,
            orderList,
            ROSSOrders,
            userData,
            error,
            isErrorResponse,
            addToCartError,
            getAuthenticatedStatus,
            ssrDeviceType,
        } = this.props;
        const breakpointExpr =  `(max-width: ${(CUSTOM_BREAKPOINTS.tabLandscape)}px)`;
        if (!orderList && !ROSSOrders) return null;
        if ((isFetchingModal) && isAuthenticated) {
            return <Loading pageTitle="Orders" />;
        }
        const seo = {
            page_title: 'My Account',
            meta_description: '',
        };

        if (featureFlags['is-atlas-maintenance-alert-enabled']) {
            return <OrderTrackingOutage />;
        }

        const isROSSEnabled = featureFlags['is-order-page-using-ross-endpoint'];
        const isROSSUIEnabled = featureFlags['is-orders-page-using-ross'];
        if ((isErrorResponse && error && error.errorMessage) || featureFlags['is-ross-error-page-enabled'] === true) {
            error.isErrorResponse = isErrorResponse;
            error.component = `Order History-${ssrDeviceType}`;
            return (
                <>
                    {isAuthenticated || getAuthenticatedStatus ? (
                        <div className={classes.TrackOrderStyle}>
                            <Media query={breakpointExpr}>
                                {(matches) => (
                                    matches ? (
                                        <div>
                                            <h1>
                                                <AccountHome />
                                                Order Tracking
                                            </h1>
                                            <ErrorPage userData={userData} errors={error} />
                                        </div>
                                    ) : (
                                        <Grid className="container" container>
                                            <AccountLeftMenu userProfile={userProfile} featureFlags={featureFlags} customClass="trackOrder" />
                                            <Grid item xs={10} style={{ padding: '20px 11px 0 43px' }}>
                                                <DesktopOrderHeader />
                                                <ErrorPage userData={userData} errors={error} />
                                            </Grid>
                                        </Grid>
                                    )
                                )}
                            </Media>
                        </div>
                    ) : (
                        <>
                            <ErrorPage userData={userData} error={error} />
                        </>
                    )}
                </>
            );
        }
        return (
            <>
                <GraphqlSeoHeadTags seoData={seo} />
                {featureFlags['is-atlas-maintenance-alert-enabled'] && (
                    <OrderTrackingOutage />
                )}
                {isAuthenticated || getAuthenticatedStatus ? (
                    <div className={classes.TrackOrderStyle}>
                        <Media query={breakpointExpr}>
                            {(matches) => (
                                matches ? (
                                    <div>
                                        <h1>
                                            <AccountHome />
                                            Order Tracking
                                        </h1>
                                        <DeliveryHours />
                                        {(orderList.length > 0 || ROSSOrders.length > 0) &&  <OrderList orders={orderList} userProfile={userProfile} ROSSOrders={isROSSEnabled ? ROSSOrders : null} isROSSUIEnabled={isROSSUIEnabled} />}
                                        {(orderList.length > 2 || ROSSOrders.length > 2) ? (
                                            <span className="back-to-top-wrapper">
                                                <a
                                                    className="back-to-top-link"
                                                    onClick={() => this.handleBackToTopClicked()}
                                                >
                                                    Back to Top <KeyboardArrowUp />
                                                </a>
                                            </span>
                                        ) : (
                                            ''
                                        )}
                                        {(orderList.length === 0 && ROSSOrders.length === 0) ? (
                                            <div>
                                                Can&apos;t find your order? Please call{' '}
                                                {getSiteConfig('phoneNumber')}
                                            </div>
                                        ) : (
                                            ''
                                        )}
                                    </div>
                                ) : (
                                    <Grid className="container" container>
                                        <AccountLeftMenu userProfile={userProfile} featureFlags={featureFlags} customClass="trackOrder" />
                                        <Grid item xs={10} style={{ padding: '20px 11px 0 43px' }}>
                                            <DesktopOrderHeader />
                                            {addToCartError?.length > 0 && this.showStockErrorMessage()}
                                            {(orderList.length > 0 || ROSSOrders.length > 0)
                                                ? (
                                                    <OrderList
                                                        orders={orderList}
                                                        userProfile={userProfile}
                                                        ROSSOrders={isROSSEnabled ? ROSSOrders : null}
                                                        isROSSUIEnabled={isROSSUIEnabled}
                                                        featureFlags={featureFlags}
                                                    />
                                                )
                                                :                                                (
                                                    <div className="desktop-no-orders">
                                                        Can&apos;t find your order? Please call{' '}
                                                        {getSiteConfig('phoneNumber')}
                                                    </div>
                                                )}
                                        </Grid>
                                    </Grid>
                                )
                            )}
                        </Media>
                    </div>
                ) : (
                    <Media query={breakpointExpr}>
                        {(matches) => (
                            matches ? (
                                <>
                                    <h1>Order Tracking</h1>
                                    <TrackOrderByZipCode featureFlags={featureFlags} />
                                </>
                            ) : (
                                <DesktopTrackOrder />
                            )
                        )}
                    </Media>
                )}
            </>
        );
    }
}

TrackOrders.defaultProps = {
    fetchOrdersByEmail: () => {},
    orderList: [],
    featureFlags: {},
    ROSSOrders: [],
    error: {},
    isErrorResponse: false,
    userData: {},
};

TrackOrders.propTypes = {
    classes: object.isRequired,
    isFetchingModal: bool.isRequired,
    fetchOrdersByEmail: func,
    orderList: arrayOf(
        shape({
            orderNumber: string,
            intOrderNumber: string,
            orderPlaceddate: string,
            customerFirstName: string,
            customerLastName: string,
            modifyOrder: string,
            parentOrderNumber: string,
            uuid: string,
            items: arrayOf(
                shape({
                    brandId: string,
                    productSku: string,
                    productName: string,
                    recpFirstName: string,
                    recpLastName: string,
                    shipDate: string,
                    paymentStatus: string,
                    estimatedDeliveryDate: string,
                    trackingNumber: string,
                    itemType: string,
                    sfItemType: string,
                    addonType: string,
                    parentLineNumber: string,
                    childLineNumber: string,
                    flexDate: string,
                    flexMessage: string,
                    flexGuaranteedFlag: string,
                    prdImgCtg: string,
                    prdImgTmn: string,
                    arrivalStartDate: string,
                    arrivalEndDate: string,
                    carrier: string,
                    seoUrl: string,
                    subscriptionType: string,
                    interval: string,
                    duration: string,
                }),
            ),
        }),
    ),
    ROSSOrders: arrayOf(
        shape({
            brandId: string,
            modifiedDateTime: string,
            orderNumber: string,
            modifyOrder: string,
            uuid: string,
            status: string,
            orders: arrayOf(
                shape({
                    carrier: string,
                    history: array,
                    brandId: string,
                    type: string,
                    deliveryDate: string,
                    modifiedDateTime: string,
                    status: string,
                    statusDescription: string,
                    trackingNumber: string,
                    warningMessage: string,
                    items: arrayOf(
                        shape({
                            duration: string,
                            interval: string,
                            itemType: string,
                            prdImgCtg: string,
                            prdImgTmn: string,
                            productName: string,
                            productSku: string,
                            seoUrl: string,
                            subscriptionType: string,
                        }),
                    ),
                }),
            ),
        }),
    ),
    userProfile: shape({
        accessToken: string,
        idToken: string,
        ContactId: string,
        userType: string,
        userRole: string,
        email: string,
        aud: string,
        iat: number,
        exp: number,
        sub: string,
        firstName: string,
        lastName: string,
        loginsCount: number,
        isAuthenticated: bool,
        isGuestAccount: bool,
    }).isRequired,
    featureFlags: object,
    error: object,
    isErrorResponse: bool,
    userData: object,
    addToCartError: string.isRequired,
    ssrDeviceType: string.isRequired,
    getAuthenticatedStatus: bool.isRequired,
    clearRossError: func.isRequired,
};

const mapStateToProps = (state) => {
    /* istanbul ignore next */
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    const isAuthenticated = state.member.auth.isAuthenticated || false;
    const userData = isAuthenticated ? ({
        firstName: state.member?.profile?.firstName || '',
        lastName: state.member?.profile?.lastName || '',
        email: state.member?.profile?.email || '',
    }) : {};
    return {
        isFetchingModal: newState.isFetchingModal,
        toggleState: newState.toggleState,
        orderList: newState.orderList,
        ROSSOrders: newState.ROSSOrders,
        error: newState.error,
        isErrorResponse: newState.isErrorResponse,
        brand: getBrand(state),
        addToCartError: getAddToCartError(state),
        ssrDeviceType: getSSRDeviceType(state),
        getAuthenticatedStatus: getIsAuthenticatedStatus(state),
        userData,
    };
};

const mapDispatchToProps = (dispatch) => ({
    fetchOrdersByEmail: (featureFlags, ssrDeviceType) => dispatch(EventDispatcher.fetchOrdersByEmail(featureFlags, ssrDeviceType)),
    clearRossError: () => dispatch(EventDispatcher.clearRossError()),
});

const enhance = compose(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
    trackPage({
        type: 'ordertracking',
        name: 'ordersearch',
        accountPage: true,
    }),
    withRouter,
    withStyles(styles, { withTheme: true }),
    withPageView({
        pageViewSuccessTest: () => true,
    }),
);
export default enhance(TrackOrders);
